import { createAction } from '@reduxjs/toolkit';

export const onDeliveryAreaToggle = createAction<boolean>('deliveryArea/trackToggle');

export const onDeliveryAreaReturnsPolicyClick = createAction(
  'deliveryArea/onDeliveryAreaReturnsPolicyClick',
);
